(function (root) {
  const MIN_INSTALLMENT_CENTS = 3000;
  const MAX_INSTALLMENTS = 10;
  const PIX_DISCOUNT_FACTOR = 0.9;

  function computePixPrice(priceCents, isEnxoval) {
    if (!Number.isFinite(priceCents) || priceCents <= 0) return 0;
    return isEnxoval ? priceCents : Math.round(priceCents * PIX_DISCOUNT_FACTOR);
  }

  function computeInstallments(totalCents) {
    let count = 1;
    for (let i = 1; i <= MAX_INSTALLMENTS; i++) {
      if (totalCents / i >= MIN_INSTALLMENT_CENTS) count = i;
    }
    return { count, valueCents: totalCents / count };
  }

  function formatMoney(cents) {
    const formatted = (cents / 100).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return `R$ ${formatted}`;
  }

  const PriceRules = { computePixPrice, computeInstallments, formatMoney };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = PriceRules;
  } else {
    root.PriceRules = PriceRules;
  }
})(typeof window !== 'undefined' ? window : globalThis);
